import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sprintName',
  pure: false
})

export class SprintNamePipe implements PipeTransform {
  transform(
    items: any[],
    filter: any,
    type: any,
    sprintname: any,
    userStoryID?: any
  ): any {
    if (type.type == 'count') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (userStoryID) { // for count based on user story/entity
          if (filter.assignedto === item.assignedto && userStoryID.entity_desc === item.entity_desc && item.completed == false && item.activity.type != 'RI') {
            if (
              item.moduleName === sprintname.sprintName
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto &&
              userStoryID.entity_desc === item.entity_desc &&
              item.completed == false && item.activity.type != 'RI'
            ) {
              count++;
            }
          }
          if (item.activity.type == 'RI') {
            if (userStoryID.entity_Id == item.primaryentity_Id) {
              count++;
            }
          }
        } else { // for count based on sprint name
          if (filter.assignedto === item.assignedto) {
            if (
              item.moduleName === sprintname.sprintName && item.completed == false
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto && item.completed == false
            ) {
              count++;
            }
          }
        }


      }
      return count;
    } else if (type.type == 'session') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (userStoryID) { // for count based on user story/entity
          if (filter.assignedto === item.assignedto && userStoryID.entity_desc === item.entity_desc && item.history == false && item.status != 1) {
            if (
              item.moduleName === sprintname.sprintName
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto &&
              userStoryID.entity_desc === item.entity_desc &&
              item.history == false &&
              item.status != 1
            ) {
              count++;
            }
          }
        } else { // for count based on sprint name
          if (filter.assignedto === item.assignedto) {
            if (
              item.moduleName === sprintname.sprintName && item.history == false && item.status != 1
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto && item.history == false && item.status != 1
            ) {
              count++;
            }
          }
        }


      }
      return count;
    } else if (type.type == 'project') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (userStoryID) { // for count based on user story/entity
          if (item.assignedto === '' && userStoryID.entity_desc === item.entity_desc && item.completed == false && item.activity.type != 'RI') {
            if (
              item.moduleName === sprintname.sprintName && item.primaryentity_Id == ''
            ) {
              count++;

            }

          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === '' &&
              userStoryID.entity_desc === item.entity_desc &&
              item.completed == false && item.activity.type != 'RI'
            ) {
              count++;

            }

          }
          if (item.activity.type == 'RI') {
            if (userStoryID.entity_Id == item.primaryentity_Id) {
              count++;
            }
          }
        } else { // for count based on Project name
          if (item.assignedto === '') {
            if (
              item.moduleName === sprintname.sprintName && item.completed == false && item.primaryentity_Id == ''
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === '' && item.completed == false && item.primaryentity_Id == ''
            ) {
              count++;
            }
          }
        }
      }
      return count;
    } else if (type.type == 'completed') {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (userStoryID) { // for count based on user story/entity
          if (filter.assignedto === item.assignedto && userStoryID.entity_desc === item.entity_desc && item.completed == true && item.activity.type != 'RI') {
            if (
              item.moduleName === sprintname.sprintName
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto &&
              userStoryID.entity_desc === item.entity_desc &&
              item.completed == true && item.activity.type != 'RI'
            ) {
              count++;
            }
          }
          if (item.activity.type == 'RI') {
            if (userStoryID.entity_Id == item.primaryentity_Id) {
              count++;
            }
          }
        } else { // for count based on sprint name
          if (filter.assignedto === item.assignedto) {
            if (
              item.moduleName === sprintname.sprintName && item.completed == true
            ) {
              count++;
            }
          } else {
            if (
              item.moduleName === sprintname.sprintName &&
              item.assignedto === filter.assignedto && item.completed == true
            ) {
              count++;
            }
          }
        }


      }
      return count;
    } else {
      let count = 0;
      if (!items || !filter) {
        return count;
      }
      for (let item of items) {
        if (item.history === filter.history) {
          return item;
        }
      }
    }
  }
}

